import React from 'react'
import { Avatar, Card ,Col, Typography} from 'antd'
import { CONSTANTS } from 'utils/constant';
import utils from 'utils';
import "./Appointment.scss";
import Icons from 'Common/Icons';
import { useTranslation, Trans } from "react-i18next";
import { PRIMARY_LANG, LANG_STYLD_EXT, TS_STYLD_COMPS } from "Common/constant";
import { useSelector } from 'react-redux';
import PhotoSkeleton from 'Components/PhotoSkeleton';


function SelectedClinicianCard(props) {
  const includePrimeLang = useSelector((state) => state.loginReducer.includePrimeLang);
  const { t, i18n } = useTranslation();
  const tgtLang = includePrimeLang
      ? i18n.language + "_" + PRIMARY_LANG
      : i18n.language;
  const tgtLangST = includePrimeLang ? tgtLang + LANG_STYLD_EXT : tgtLang;
   const handleEditAction = ()=>{
      typeof props?.redirectTo == "function" && props.redirectTo("preferred-clinician", true)
    }
  return (
    props.slots_loader==false ? 
    <div>
      <Card className='app-selected-clinician-card'>
        <div className='selected-clinician-card-header'>
          <Trans components={TS_STYLD_COMPS}>
            {t(CONSTANTS.SELECTED_CLINICIAN, { lng: tgtLangST })}
          </Trans>
        </div>
        <div className='selected-clinician-card-body-container'>
            <div>
              <PhotoSkeleton src={props?.doctorSelectedData.profile_picture}>
                <Avatar size={48} icon={<img className='selected-doc-img' src={props?.doctorSelectedData.profile_picture}/>}/>
              </PhotoSkeleton>
            </div>
            <div>
                <div className="selected-doc-name">
                <Typography.Text ellipsis={{ tooltip:  props.doctorSelectedData?.salutation && `${utils.ConvertToPascalCase(props.doctorSelectedData.salutation)}`+" "+`${props.doctorSelectedData?.clinician_first_name}`+" "+`${props.doctorSelectedData?.clinician_last_name && props.doctorSelectedData?.clinician_last_name}`  }} >
                {props.doctorSelectedData?.salutation && `${utils.ConvertToPascalCase(props.doctorSelectedData.salutation)}.`}&nbsp;{props.doctorSelectedData?.clinician_first_name}&nbsp;{props.doctorSelectedData?.clinician_last_name && props.doctorSelectedData?.clinician_last_name} </Typography.Text>
                </div>
                <div className="selected-doc-spec">{props.doctorSelectedData?.qualification}</div>
            </div>
            <div className='selected-clinician-edit-icon-container'>
                <img onClick={handleEditAction} src={Icons.selected_clinician_edit_icon}/>
            </div>
        </div>
      </Card>
    </div>
    :
    null
  )
}

export default SelectedClinicianCard
